import { mediaSrc, isVideo } from "../utils/media";
import "../styles/FeedbackPage.css";

function FeedbackCard({ item }) {
  const src = mediaSrc(item.picha || item.img || item.avatar);
  const video = isVideo({ ...item, img: src || item.img || item.picha });
  const name = item.name || item.title || "Guest";

  return (
    <div className="fb-card">
      <div className="fb-picha-wrap">
        {src && video ? (
          <video src={src} className="fb-picha" muted playsInline controls />
        ) : src ? (
          <img src={src} alt={`${name}'s `} className="fb-picha" />
        ) : (
          <div className="fb-picha-placeholder">Photo</div>
        )}
      </div>
      <div className="fb-card-footer">
        <div className="fb-avatar">
          {src && !video ? (
            <img src={src} alt={name} className="fb-avatar-img" />
          ) : (
            <div className="fb-avatar-initials">{item.initials || name.slice(0, 2).toUpperCase()}</div>
          )}
        </div>
        <div>
          <div className="fb-name">{name}</div>
          {item.role && <div className="fb-role">{item.role}</div>}
        </div>
      </div>
    </div>
  );
}

export default function FeedbackPage({ feedbackItems = [] }) {
  return (
    <div className="page fbp-page">
      <div className="fbp-hero">
        <div className="section-ornament">
          <div className="section-ornament-line" />
          <span className="section-label">Testimonials</span>
          <div className="section-ornament-line" />
        </div>
        <h1 className="fbp-title">Happy <em>Customers</em></h1>
        <div className="section-rule" style={{ margin: "18px auto" }} />
        <p className="fbp-sub">
          Real moments shared by collectors, students, and visitors.
        </p>
      </div>

      <div className="section fbp-section">
        {feedbackItems.length === 0 ? (
          <p style={{ textAlign: "center", color: "var(--ink-faint)", padding: "40px 0" }}>
            No feedback photos yet. Upload them from Admin → Customer Feedback.
          </p>
        ) : (
          <div className="fb-grid">
            {feedbackItems.map((item) => (
              <FeedbackCard key={item.id} item={item} />
            ))}
          </div>
        )}
        <div className="fbp-cta">
          <div className="fbp-cta-inner">
            <h3 className="fbp-cta-title">Share Your Experience</h3>
            <p className="fbp-cta-desc">Visited the gallery or attended a workshop? We'd love to feature your story.</p>
            <a href="mailto:feedback@dicksonartgallery.com" className="btn btn-primary">Send Your Photo &amp; Story →</a>
          </div>
        </div>
      </div>
    </div>
  );
}
